import { doc, Firestore, writeBatch } from "firebase/firestore";
import { setting } from "shared/types/Report";
import { defaultReportSetting } from "./reportDefaults";

export const createReportWithSettings = async (db: Firestore, path: string, name: string): Promise<void> => {
    const batch = writeBatch(db);
    batch.set(doc(db, path), { name, type: "report" });
    batch.set(doc(db, `${path}/Content/setting`), defaultReportSetting);
    await batch.commit();
};

export const saveReportWithSettings = async (
    db: Firestore, path: string, content: { word: unknown[]; sentence: unknown[]; video: unknown[] }, settings: setting,
): Promise<void> => {
    const batch = writeBatch(db);
    for (const [type, items] of Object.entries(content)) {
        const ref = doc(db, `${path}/Content/${type}`);
        if (items.length) batch.set(ref, { content: items });
    }
    batch.set(doc(db, `${path}/Content/setting`), settings);
    await batch.commit();
};
